// extracted by mini-css-extract-plugin
module.exports = {"small":"_98931","medium":"_053ba","large":"_392e2"};